<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>PART IV</span></p>
<p class="chap-title-2"><span>OTIS SKEDADDLES</span></p>
<p class="normal-a"><i>The swift thought came to him that the generals did not know what they were about. It was all a trap</i>.</p>
<p class="right"><span>—S<span class="smallcaps">TEPHEN</span> C<span class="smallcaps">RANE</span>, <i>T<span class="smallcaps">HE</span> R<span class="smallcaps">ED</span> B<span class="smallcaps">ADGE OF</span> C<span class="smallcaps">OURAGE</span></i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part4chapter01.vue?61f29772